/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from "@/components/cusPagination.vue";
import {
  noticeGet,
  noticepost,
  noticeSeach,
  noticePut,
  noticeDel,
  startPut,
  bearPut,
} from "@/api/notice";
import E from "wangeditor";
import { fileEcho, fileUp } from "@/api/url";

export default {
  components: {
    CusPagination,
  },
  data() {
    return {
      loading: false,
      addDialog: false, //新增弹框
      detailsDialog: false, //详情弹框
      searchForm: {
        title: "",
        publishTime: "",
      },
      stateText: "",
      tabsCut: 0,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      addOrEdit: true, //true 新增公告  false 编辑
      editor: null, //副文本
      editorId: "", //富文本id
      rowId: "",
      tableDataLoc: fileEcho,
      fileUp: fileUp,
      token: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      ruleForm: {
        id: "",
        obj: "",
        title: "",
        content: "",
        link: "",
      },
      rules: {
        obj: [
          {
            required: true,
            message: "请至少选择一个发送范围",
            trigger: "change",
          },
        ],
        title: [
          { required: true, message: "请输入公告标题", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到 128 个字符",
            trigger: "blur",
          },
        ],
      },
      detail: {
        title: "", //公告标题
        obj: "", //公告标题
        link: "", //公告标题
        content: "", //公告标题
      }, //详情
    };
  },
  // 自定义方法
  methods: {
    //搜索
    seachBtn() {
      this.getList();
    },
    //重置
    resetBtn() {
      this.searchForm.title = "";
      this.searchForm.publishTime = "";
      this.cutCreatedDate = "";
      this.getList();
    },
    //获取列表
    getList() {
      if (this.searchForm.publishTime.length > 0) {
        this.cutCreatedDate =
          this.searchForm.publishTime[0] + "," + this.searchForm.publishTime[1];
      }
      this.loading = true;
      this.$ajax
        .get(noticeGet, {
          title: this.searchForm.title,
          published: this.stateText,
          publishTime: this.cutCreatedDate,
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
        })
        .then(
          (res) => {
            if (res.status === 200) {
              // 成功了
              this.tableData = res.data.rows;
              this.total = res.data.total;
              this.loading = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
    //切换
    cut(num) {
      if (num == 0) {
        this.tabsCut = 0;
        this.stateText = "";
        this.getList();
      } else if (num == 1) {
        this.tabsCut = 1;
        this.stateText = true;
        this.getList();
      } else if (num == 2) {
        this.tabsCut = 2;
        this.stateText = false;
        this.getList();
      }
    },
    //新增公告弹框打开
    addClick() {
      this.addOrEdit = true;
      this.addDialog = true;
      setTimeout(
        function() {
          document.getElementById("editorElem").innerHTML = "";
          this.richText();
          this.editor.txt.html("");
        }.bind(this),
        100
      );
      this.ruleForm.obj = "";
      this.ruleForm.title = "";
      this.ruleForm.link = "";
    },
    //编辑
    editClick(row) {
      setTimeout(
        function() {
          this.richText();
          this.editor.txt.html(row.content);
        }.bind(this),
        100
      );
      this.ruleForm.obj = row.obj.slice();
      this.ruleForm.title = row.title;
      this.ruleForm.link = row.link;
      this.addOrEdit = false;
      this.addDialog = true;
      this.rowId = row.id;
      this.ruleForm.id = row.id;
    },
    //存为草稿-发送
    submitBtn(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editor.txt.html() == "" && this.ruleForm.link == "") {
            this.$message.error("请输入公告内容或公告链接");
            return false;
          }
          if (type == 1) {
            var fromData = {
              id: this.ruleForm.id,
              obj: this.ruleForm.obj,
              title: this.ruleForm.title,
              content: this.editor.txt.html(),
              link: this.ruleForm.link,
              published: false,
            };
          } else if (type == 2) {
            var fromData = {
              id: this.ruleForm.id,
              obj: this.ruleForm.obj,
              title: this.ruleForm.title,
              content: this.editor.txt.html(),
              link: this.ruleForm.link,
              published: true,
            };
          }
          if (this.addOrEdit == true) {
            this.$ajax.post(noticepost, fromData).then(
              (res) => {
                if (res.status === 200) {
                  // 成功了
                  this.getList();
                  this.addDialog = false;
                }
              },
              (err) => {
                console.log(err);
              }
            );
          } else if (this.addOrEdit == false) {
            this.$ajax.put(noticePut(this.rowId), fromData).then(
              (res) => {
                if (res.status === 200) {
                  // 成功了
                  this.getList();
                  this.addDialog = false;
                }
              },
              (err) => {
                console.log(err);
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //新增-取消
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.addDialog = false;
    },
    //详情
    detailsClick(row) {
      this.detail.title = row.title;
      this.detail.obj = row.obj;
      this.detail.link = row.link;
      this.detail.content = row.content;
      this.detailsDialog = true;
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将删除此公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.delete(noticeDel(row.id)).then(
            (res) => {
              if (res.status === 200) {
                // 成功了
                this.getList();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            },
            (err) => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    //启用
    startClick(row) {
      this.$confirm("此操作将启用此公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.put(startPut(row.id)).then(
            (res) => {
              if (res.status === 200) {
                // 成功了
                this.getList();
                this.$message({
                  type: "success",
                  message: "启用成功!",
                });
              }
            },
            (err) => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    //禁用
    bearClick(row) {
      this.$confirm("此操作将禁用此公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.put(bearPut(row.id)).then(
            (res) => {
              if (res.status === 200) {
                // 成功了
                this.getList();
                this.$message({
                  type: "success",
                  message: "禁用成功!",
                });
              }
            },
            (err) => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    //富文本渲染
    richText() {
      this.editor = new E("#editorElem");
      this.editor.config.menus = [
        "head",
        "bold",
        "fontSize",
        "fontName",
        "italic",
        "underline",
        "strikeThrough",
        "indent",
        "lineHeight",
        "foreColor",
        "backColor",
        "link",
        "list",
        "justify",
        "quote",
        "emoticon",
        "image",
        "table",
        "code",
        "splitLine",
        "undo",
        "redo",
      ];
      this.editor.config.uploadImgServer =
        this.fileUp + "?keepActive=true&originalProxy=fullText"; //'http://192.168.0.107:8082/app/files/richTextUpload';//this.fileUp;  // 上传图片到服务器
      // this.editor.config.uploadImgShowBase64 = true;   // 使用 base64 保存图片
      this.editor.config.uploadImgAccept = ["jpg", "jpeg", "png", "gif", "bmp"];
      this.editor.config.debug = true; // 开启debug模式
      this.editor.config.uploadImgHeaders = {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      };
      // 3M
      this.editor.config.uploadImgMaxSize = 3 * 1024 * 1024;
      // 限制一次最多上传 1 张图片
      this.editor.config.uploadImgMaxLength = 1;
      // 上传文件参数
      this.editor.config.uploadFileName = "file";
      // 将 timeout 时间改为 5s
      this.editor.config.uploadImgTimeout = 5000;
      this.editor.create(); //创建实例
      this.editor.config.uploadImgHooks = {
        before: function(xhr, editor, files) {
          // 图片上传之前触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
          // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
          // return {
          //     prevent: true,
          //     msg: '放弃上传'
          // }
          // alert("前奏");
        },
        success: function(xhr, editor, result) {
          // 图片上传并返回结果，图片插入成功之后触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          // var url = result.data.url;
          // alert(JSON.stringify(url));
          // editor.txt.append(url);
          // alert("成功");
        },
        fail: function(xhr, editor, result) {
          // 图片上传并返回结果，但图片插入错误时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        },
        error: function(xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          // alert("错误");
        },
        // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
        // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
        customInsert: function(insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          insertImg(fileEcho + result.watermark);
          // result 必须是一个 JSON 格式字符串！！！否则报错
        },
      };
    },
  },
  // 数据观察监听
  watch: {
    currentPage(newData, oldData) {
      this.getList();
    },
    pageSize(newData, oldData) {
      this.getList();
    },
  },
  // 计算数据
  computed: {},
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {
    this.getList();
  },
  // 组件挂载完成之前
  beforeMount() {},
  // 组件挂载完成
  mounted() {
    // if(this.goodsDetail){
    //     this.editor.disable()
    // }
  },
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {},
};
